import React from 'react'

export function Contact() {
  return (
    <div>
      <h2>Estamos en el Contact</h2>
    </div>
  )
}
